import {useEffect, useState} from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { usePagination } from "../hooks/usePagination";
import UniversalPagination from "../common/UniversalPagination";
import Swal from "sweetalert2";

import { API_BASE } from '../config/api'

function ConfigDistribuidor() {

    const [distyNombre, setDistyNombre] = useState("");
    const [distyPassword, setDistyPassword] = useState("");
    const [distyRegionId, setDistyRegionId] = useState("");
    const [distyPlanId, setDistyPlanId] = useState("");
    const [distyImageFile, setDistyImageFile] = useState(null);

    const [regions, setRegions] = useState([]);
    const [plans, setPlans] = useState([]);

    const [showPassword, setShowPassword] = useState(false);
    const [savingDisty, setSavingDisty] = useState(false);

    const [successMessage, setSuccessMessage] = useState("");
    const [infoMessage, setInfoMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [distributors, setDistributors] = useState([]);
    const [loadingDistributors, setLoadingDistributors] = useState(false);
    const [visiblePasswords, setVisiblePasswords] = useState({});

    const [loadingViewDisty, setLoadingViewDisty] = useState(false);
    const [viewDistyError, setViewDistyError] = useState("");
    const [viewDistyData, setViewDistyData] = useState(null);
    const [showViewDistyPassword, setShowViewDistyPassword] = useState(false);

    const [loadingEditDisty, setLoadingEditDisty] = useState(false);
    const [savingEditDisty, setSavingEditDisty] = useState(false);
    const [editDistyError, setEditDistyError] = useState("");
    const [editDistySuccess, setEditDistySuccess] = useState("");
    const [editDistyInfo, setEditDistyInfo] = useState("");

    const [editDistyId, setEditDistyId] = useState(null);
    const [editDistyNombre, setEditDistyNombre] = useState("");
    const [editDistyPassword, setEditDistyPassword] = useState("");
    const [editDistyRegionId, setEditDistyRegionId] = useState("");
    const [editDistyPlanId, setEditDistyPlanId] = useState("");
    const [editDistyImageUrl, setEditDistyImageUrl] = useState("");
    const [editDistyImageFile, setEditDistyImageFile] = useState(null);
    const [showEditDistyPassword, setShowEditDistyPassword] = useState(false);

    const [filterRegionId, setFilterRegionId] = useState("");
    const [filterPlanId, setFilterPlanId] = useState("");
    const [searchDisty, setSearchDisty] = useState("");
    

    useEffect(() => {
        loadConfigDistyCatalogs();
        loadDistributors();
    }, []);

    const loadConfigDistyCatalogs = async () => {
        try {
            setErrorMessage("");

            const [regionsResp, plansResp] = await Promise.all([
                fetch(`${API_BASE}/api/admin/configDisty/regions`, {
                    method: "GET",
                    credentials: "include",
                }),
                fetch(`${API_BASE}/api/admin/configDisty/plans`, {
                    method: "GET",
                    credentials: "include",
                }),
            ]);

            const regionsData = await regionsResp.json();
            const plansData = await plansResp.json();

            if (!regionsResp.ok) {
                throw new Error(regionsData?.message || "No fue posible obtener las regiones");
            }

            if (!plansResp.ok) {
                throw new Error(plansData?.message || "No fue posible obtener los planes");
            }

            setRegions(regionsData.data || []);
            setPlans(plansData.data || []);
        } catch (error) {
            console.error("Error cargando catálogos de distribuidores:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar regiones y planes");
        }
    };

    const toggleDistributorPassword = (distyId) => {
        setVisiblePasswords((prev) => ({
            ...prev,
            [distyId]: !prev[distyId],
        }));
    };

    // Funcion para limpiar el modal 
    const resetAddDistyForm = () => {
    setDistyNombre("");
    setDistyPassword("");
    setDistyRegionId("");
    setDistyPlanId("");
    setDistyImageFile(null);
    setShowPassword(false);

    setSuccessMessage("");
    setInfoMessage("");
    setErrorMessage("");

    const fileInput = document.getElementById("customFile1");
        if (fileInput) fileInput.value = "";
    };

    const validateAddDistyForm = () => {
    if (!distyNombre.trim()) {
        setInfoMessage("El campo (nombre) es obligatorio");
        return false;
    }

    if (!distyPassword.trim()) {
        setInfoMessage("El campo (password) es obligatorio");
        return false;
    }

    if (!distyRegionId) {
        setInfoMessage("El campo (región) es obligatorio");
        return false;
    }

    if (!distyPlanId) {
        setInfoMessage("El campo (plan) es obligatorio");
        return false;
    }

    if (!distyImageFile) {
        setInfoMessage("Debes seleccionar una imagen");
        return false;
    }

    return true;
    };

    const uploadDistributorImage = async () => {
        if (!distyImageFile) {
            throw new Error("Debes seleccionar una imagen");
        }

        const formData = new FormData();
        formData.append("image", distyImageFile);

        const response = await fetch(`${API_BASE}/api/admin/configDistyPhoto`, {
            method: "POST",
            credentials: "include",
            body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data?.message || "No fue posible subir la imagen");
        }

        return data?.data?.publicUrl || null;
    };

    const loadDistributors = async () => {
        try {
            setLoadingDistributors(true);
            setErrorMessage("");

            const response = await fetch(`${API_BASE}/api/admin/configDisty`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener los distribuidores");
            }

            setDistributors(data?.data || []);
        } catch (error) {
            console.error("Error al cargar distribuidores:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar distribuidores");
        } finally {
            setLoadingDistributors(false);
        }
    };

    const handleDistributorImageChange = (e) => {
        setInfoMessage("");
        setErrorMessage("");
        setSuccessMessage("");

        const file = e.target.files?.[0] || null;

        if (!file) {
            setDistyImageFile(null);
            return;
        }

        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

        if (!allowedTypes.includes(file.type)) {
            setDistyImageFile(null);
            e.target.value = "";
            setInfoMessage("Solo se permiten imágenes JPG, PNG o WEBP");
            return;
        }

        setDistyImageFile(file);
    };

    // Funcion para guardar cambios
    const handleSaveDistributor = async () => {
    try {
            setSuccessMessage("");
            setInfoMessage("");
            setErrorMessage("");

            const isValid = validateAddDistyForm();
            if (!isValid) return;

            setSavingDisty(true);

            const imageUrl = await uploadDistributorImage();

            const payload = {
                Disty_Nombre: distyNombre.trim(),
                Disty_Imagen: imageUrl,
                Disty_Region_ID: Number(distyRegionId),
                Disty_Plan_ID: Number(distyPlanId),
                Password_Default: distyPassword.trim(),
            };

            const response = await fetch(`${API_BASE}/api/admin/configDisty`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "Ocurrió un error al guardar el distribuidor");
            }

            setSuccessMessage("Distribuidor guardado correctamente");

            resetAddDistyForm();
            setSuccessMessage("Distribuidor guardado correctamente");

            // Si tienes listado de distribuidores, aquí puedes recargarlo:
            await loadDistributors();

            // Si quieres cerrar el modal automáticamente después de guardar:
            // const modalEl = document.getElementById("addDistributorModal");
            // const modalInstance = window.bootstrap?.Modal.getInstance(modalEl);
            // modalInstance?.hide();

        } catch (error) {
            console.error("Error al guardar distribuidor:", error);
            setErrorMessage(error.message || "Ocurrió un error");
        } finally {
            setSavingDisty(false);
        }
    };

    // Funcion para ver Distribuidor
    const handleViewDisty = async (distyId) => {
        try {
            setLoadingViewDisty(true);
            setViewDistyError("");
            setViewDistyData(null);
            setShowViewDistyPassword(true);

            const response = await fetch(`${API_BASE}/api/admin/configDisty/${distyId}`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener el detalle del distribuidor");
            }

            setViewDistyData(data.data);
        } catch (error) {
            console.error("Error al obtener detalle del distribuidor:", error);
            setViewDistyError(error.message || "Ocurrió un error al obtener el detalle del distribuidor");
        } finally {
            setLoadingViewDisty(false);
        }
    };

    // Funcion para editar Distribuidor
    const handleEditDisty = async (distyId) => {
        try {
            setLoadingEditDisty(true);
            setEditDistyError("");
            setEditDistySuccess("");
            setEditDistyInfo("");
            setEditDistyPassword("");
            setEditDistyImageFile(null);
            setShowEditDistyPassword(false);

            const response = await fetch(`${API_BASE}/api/admin/configDisty/${distyId}`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener el distribuidor");
            }

            const disty = data.data;

            setEditDistyId(disty.Disty_ID);
            setEditDistyNombre(disty.Disty_Nombre || "");
            setEditDistyRegionId(disty.Disty_Region_ID || "");
            setEditDistyPlanId(disty.Disty_Plan_ID || "");
            setEditDistyImageUrl(disty.Disty_Imagen || "");
        } catch (error) {
            console.error("Error al cargar distribuidor:", error);
            setEditDistyError(error.message || "Ocurrió un error al cargar el distribuidor");
        } finally {
            setLoadingEditDisty(false);
        }
    };

    const handleEditDistyImageChange = (e) => {
        setEditDistyError("");
        setEditDistyInfo("");
        setEditDistySuccess("");

        const file = e.target.files?.[0] || null;

        if (!file) {
            setEditDistyImageFile(null);
            return;
        }

        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

        if (!allowedTypes.includes(file.type)) {
            e.target.value = "";
            setEditDistyImageFile(null);
            setEditDistyInfo("Solo se permiten imágenes JPG, PNG o WEBP");
            return;
        }

        setEditDistyImageFile(file);
    };

    const uploadEditDistyImage = async () => {
        if (!editDistyImageFile) return editDistyImageUrl;

        const formData = new FormData();
        formData.append("image", editDistyImageFile);

        const response = await fetch(`${API_BASE}/api/admin/configDistyPhoto`, {
            method: "POST",
            credentials: "include",
            body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data?.message || "No fue posible subir la imagen");
        }

        return data?.data?.publicUrl || editDistyImageUrl;
    };

    const handleUpdateDisty = async () => {
        try {
            setEditDistyError("");
            setEditDistySuccess("");
            setEditDistyInfo("");

            if (!editDistyNombre.trim()) {
                setEditDistyInfo("El campo (nombre) es obligatorio");
                return;
            }

            if (!editDistyRegionId) {
                setEditDistyInfo("El campo (región) es obligatorio");
                return;
            }

            if (!editDistyPlanId) {
                setEditDistyInfo("El campo (plan) es obligatorio");
                return;
            }

            if (!editDistyImageUrl && !editDistyImageFile) {
                setEditDistyInfo("Debes seleccionar una imagen");
                return;
            }

            setSavingEditDisty(true);

            const finalImageUrl = await uploadEditDistyImage();

            const payload = {
                Disty_Nombre: editDistyNombre.trim(),
                Disty_Imagen: finalImageUrl,
                Disty_Region_ID: Number(editDistyRegionId),
                Disty_Plan_ID: Number(editDistyPlanId),
            };

            if (editDistyPassword.trim()) {
                payload.Password_Default = editDistyPassword.trim();
            }

            const response = await fetch(`${API_BASE}/api/admin/configDisty/${editDistyId}`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible actualizar el distribuidor");
            }

            setEditDistySuccess("Distribuidor actualizado correctamente");
            setEditDistyPassword("");
            setEditDistyImageFile(null);

            await loadDistributors();
        } catch (error) {
            console.error("Error al actualizar distribuidor:", error);
            setEditDistyError(error.message || "Ocurrió un error al actualizar el distribuidor");
        } finally {
            setSavingEditDisty(false);
        }
    };

    // Funcion para eliminar Distribuidor
    const handleDeactivateDisty = async (disty) => {
    try {
    const result = await Swal.fire({
        title: "¿Desactivar distribuidor?",
        html: `
            <div style="font-size:15px;">
                Esta acción es <b>irreversible</b> desde este panel.<br/><br/>
                Si deseas <b>activar nuevamente</b> este distribuidor,
                deberás consultar con el área de soporte.
            </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, desactivar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
    });

    if (!result.isConfirmed) return;

    const response = await fetch(
        `${API_BASE}/api/admin/configDisty/${disty.Disty_ID}`,
        {
            method: "DELETE",
            credentials: "include",
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new Error(
            data?.message || "No fue posible desactivar el distribuidor"
        );
    }

    await Swal.fire({
        title: "Distribuidor desactivado",
        text: `${disty.Disty_Nombre} fue desactivado correctamente.`,
        icon: "success",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#198754",
    });

    // refresca tabla
    await loadDistributors();

    } catch (error) {
    console.error("Error al desactivar distribuidor:", error);

    Swal.fire({
        title: "Ocurrió un error",
        text:
            error.message ||
            "No fue posible desactivar el distribuidor",
        icon: "error",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#dc3545",
    });
    }
    };

    // Filtros
    const filteredDistributors = distributors.filter((disty) => {
        const search = searchDisty.toLowerCase().trim();

        const matchesSearch = search
            ? disty.Disty_Nombre?.toLowerCase().includes(search)
            : true;

        const matchesRegion = filterRegionId
            ? Number(disty.Disty_Region_ID) === Number(filterRegionId)
            : true;

        const matchesPlan = filterPlanId
            ? Number(disty.Disty_Plan_ID) === Number(filterPlanId)
            : true;

        return matchesSearch && matchesRegion && matchesPlan;
    });

    // Paginador

    const {
        currentPage,
        totalPages,
        totalItems,
        paginatedItems,
        visiblePages,
        startItem,
        endItem,
        goToPage,
        goToPreviousPage,
        goToNextPage,
        resetPagination,
        hasPreviousPage,
        hasNextPage,
    } = usePagination(filteredDistributors, 8, 5);

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">

                {/* Titulos */}
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Distribuidores</h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div className="card-header d-flex justify-content-end gap-3 flex-wrap">
                                <div className="row g-2 align-items-end w-100">
                                <div className="col-md-4">
                                <label className="form-label mb-1">Buscar</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Buscar distribuidor..."
                                    value={searchDisty}
                                    onChange={(e) => {
                                        setSearchDisty(e.target.value);
                                        resetPagination();
                                    }}
                                />
                                </div>

                                <div className="col-md-2">
                                <label className="form-label mb-1">Region</label>
                                <select
                                    className="form-select form-select-sm shadow-none"
                                    value={filterRegionId}
                                    onChange={(e) => {
                                        setFilterRegionId(e.target.value);
                                        resetPagination();
                                    }}
                                    style={{ maxWidth: "220px" }}
                                >
                                    <option value="">Todas las regiones</option>
                                    {regions.map((region) => (
                                        <option key={region.Region_ID} value={region.Region_ID}>
                                            {region.Region_Nombre}
                                        </option>
                                    ))}
                                </select>
                                </div>

                                <div className="col-md-2">
                                <label className="form-label mb-1">Plan</label>
                                <select
                                    className="form-select form-select-sm shadow-none"
                                    value={filterPlanId}
                                    onChange={(e) => {
                                        setFilterPlanId(e.target.value);
                                        resetPagination();
                                    }}
                                    style={{ maxWidth: "220px" }}
                                >
                                    <option value="">Todos los planes</option>
                                    {plans.map((plan) => (
                                        <option key={plan.Plan_ID} value={plan.Plan_ID}>
                                            {plan.Plan_Nombre}
                                        </option>
                                    ))}
                                </select>
                                </div>

                                <div className="col-md-4 d-flex justify-content-end gap-2 ms-auto">
                                <button
                                    type="button"
                                    className="btn btn-secondary-subtle btn-sm"
                                    onClick={() => {
                                        setSearchDisty("");
                                        setFilterRegionId("");
                                        setFilterPlanId("");
                                        resetPagination();
                                    }}
                                >
                                    <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.4">
                                        <path
                                            d="M4.88076 14.6713C4.74978 14.2784 4.32504 14.066 3.93208 14.197C3.53912 14.328 3.32675 14.7527 3.45774 15.1457L4.88076 14.6713ZM20.8808 15.1457C21.0117 14.7527 20.7994 14.328 20.4064 14.197C20.0135 14.066 19.5887 14.2784 19.4577 14.6713L20.8808 15.1457ZM4.16925 14.9085C3.45774 15.1457 3.45785 15.146 3.45797 15.1464C3.45802 15.1465 3.45815 15.1469 3.45825 15.1472C3.45845 15.1478 3.45868 15.1485 3.45895 15.1493C3.45948 15.1509 3.46013 15.1528 3.46092 15.1551C3.46249 15.1597 3.46456 15.1657 3.46716 15.1731C3.47235 15.188 3.47961 15.2084 3.48902 15.2341C3.50782 15.2854 3.53521 15.3576 3.5717 15.4477C3.64461 15.6279 3.7542 15.8805 3.90468 16.1814C4.2048 16.7817 4.67223 17.5836 5.34308 18.3886C6.68942 20.0043 8.88343 21.6585 12.1693 21.6585V20.1585C9.45507 20.1585 7.64908 18.8128 6.49542 17.4284C5.91627 16.7334 5.5087 16.0354 5.24632 15.5106C5.11555 15.2491 5.02201 15.0329 4.96212 14.8849C4.9322 14.811 4.91076 14.7543 4.89733 14.7177C4.89062 14.6994 4.88593 14.6861 4.88318 14.6783C4.88181 14.6744 4.88093 14.6718 4.88053 14.6706C4.88033 14.67 4.88025 14.6698 4.88029 14.6699C4.88031 14.67 4.88036 14.6701 4.88044 14.6704C4.88047 14.6705 4.88056 14.6707 4.88058 14.6708C4.88067 14.671 4.88076 14.6713 4.16925 14.9085ZM12.1693 21.6585C15.4551 21.6585 17.6491 20.0043 18.9954 18.3886C19.6663 17.5836 20.1337 16.7817 20.4338 16.1814C20.5843 15.8805 20.6939 15.6279 20.7668 15.4477C20.8033 15.3576 20.8307 15.2854 20.8495 15.2341C20.8589 15.2084 20.8662 15.188 20.8713 15.1731C20.8739 15.1657 20.876 15.1597 20.8776 15.1551C20.8784 15.1528 20.879 15.1509 20.8796 15.1493C20.8798 15.1485 20.8801 15.1478 20.8803 15.1472C20.8804 15.1469 20.8805 15.1465 20.8805 15.1464C20.8807 15.146 20.8808 15.1457 20.1693 14.9085C19.4577 14.6713 19.4578 14.671 19.4579 14.6708C19.4579 14.6707 19.458 14.6705 19.4581 14.6704C19.4581 14.6701 19.4582 14.67 19.4582 14.6699C19.4583 14.6698 19.4582 14.67 19.458 14.6706C19.4576 14.6718 19.4567 14.6744 19.4553 14.6783C19.4526 14.6861 19.4479 14.6994 19.4412 14.7177C19.4277 14.7543 19.4063 14.811 19.3764 14.8849C19.3165 15.0329 19.223 15.2491 19.0922 15.5106C18.8298 16.0354 18.4222 16.7334 17.8431 17.4284C16.6894 18.8128 14.8834 20.1585 12.1693 20.1585V21.6585Z"
                                            fill="currentColor"></path>
                                        <path d="M21.5183 19.2271C21.4293 19.2234 21.3427 19.196 21.2671 19.1465L16.3546 15.8924C16.2197 15.8026 16.1413 15.6537 16.148 15.4969C16.1546 15.34 16.2452 15.1982 16.3873 15.1202L21.5571 12.2926C21.7075 12.2106 21.8932 12.213 22.0416 12.3003C22.1907 12.387 22.2783 12.5436 22.2712 12.7096L22.014 18.7913C22.007 18.9573 21.9065 19.1059 21.7506 19.1797C21.6772 19.215 21.597 19.2305 21.5183 19.2271" fill="currentColor"></path>
                                        </g>
                                        <path
                                        d="M20.0742 10.0265C20.1886 10.4246 20.6041 10.6546 21.0022 10.5401C21.4003 10.4257 21.6302 10.0102 21.5158 9.61214L20.0742 10.0265ZM4.10803 8.88317C3.96071 9.27031 4.15513 9.70356 4.54226 9.85087C4.92939 9.99818 5.36265 9.80377 5.50996 9.41664L4.10803 8.88317ZM20.795 9.81934C21.5158 9.61214 21.5157 9.6118 21.5156 9.61144C21.5155 9.61129 21.5154 9.6109 21.5153 9.61059C21.5152 9.60998 21.515 9.60928 21.5147 9.60848C21.5143 9.60689 21.5137 9.60493 21.513 9.6026C21.5116 9.59795 21.5098 9.59184 21.5075 9.58431C21.503 9.56925 21.4966 9.54853 21.4882 9.52251C21.4716 9.47048 21.4473 9.39719 21.4146 9.3056C21.3493 9.12256 21.2503 8.8656 21.1126 8.55861C20.8378 7.94634 20.4044 7.12552 19.7678 6.29313C18.4902 4.62261 16.3673 2.87801 13.0844 2.74053L13.0216 4.23922C15.7334 4.35278 17.4816 5.77291 18.5763 7.20436C19.1258 7.92295 19.5038 8.63743 19.744 9.17271C19.8638 9.43949 19.9482 9.65937 20.0018 9.80972C20.0286 9.88483 20.0477 9.94238 20.0596 9.97951C20.0655 9.99808 20.0696 10.0115 20.072 10.0195C20.0732 10.0235 20.074 10.0261 20.0744 10.0273C20.0746 10.0278 20.0746 10.0281 20.0746 10.028C20.0746 10.0279 20.0745 10.0278 20.0745 10.0275C20.0744 10.0274 20.0744 10.0272 20.0743 10.0271C20.0743 10.0268 20.0742 10.0265 20.795 9.81934ZM13.0844 2.74053C9.80146 2.60306 7.54016 4.16407 6.12741 5.72193C5.42345 6.49818 4.92288 7.27989 4.59791 7.86704C4.43497 8.16144 4.31491 8.40923 4.23452 8.58617C4.1943 8.67471 4.16391 8.7457 4.14298 8.79616C4.13251 8.82139 4.1244 8.84151 4.11859 8.85613C4.11568 8.86344 4.11336 8.86938 4.1116 8.8739C4.11072 8.87616 4.10998 8.87807 4.10939 8.87962C4.10909 8.88039 4.10883 8.88108 4.1086 8.88167C4.10849 8.88196 4.10834 8.88234 4.10829 8.88249C4.10815 8.88284 4.10803 8.88317 4.80899 9.14991C5.50996 9.41664 5.50985 9.41692 5.50975 9.41719C5.50973 9.41725 5.50964 9.41749 5.50959 9.4176C5.5095 9.41784 5.50945 9.41798 5.50942 9.41804C5.50938 9.41816 5.50947 9.41792 5.50969 9.41734C5.51014 9.41619 5.51113 9.41365 5.51267 9.40979C5.51574 9.40206 5.52099 9.38901 5.52846 9.37101C5.5434 9.335 5.56719 9.27924 5.60018 9.20664C5.66621 9.0613 5.76871 8.84925 5.91031 8.59341C6.19442 8.08008 6.63084 7.39971 7.23855 6.72958C8.44912 5.39466 10.3098 4.12566 13.0216 4.23922L13.0844 2.74053Z"
                                        fill="currentColor"></path>
                                        <path d="M8.78337 9.33604C8.72981 9.40713 8.65805 9.46292 8.57443 9.49703L3.1072 11.6951C2.95672 11.7552 2.78966 11.7352 2.66427 11.6407C2.53887 11.5462 2.47359 11.3912 2.48993 11.2299L3.09576 5.36863C3.11367 5.19823 3.22102 5.04666 3.37711 4.97402C3.5331 4.9005 3.71173 4.91728 3.84442 5.01726L8.70581 8.68052C8.8385 8.78051 8.90387 8.94759 8.8762 9.1178C8.86358 9.19825 8.83082 9.27308 8.78337 9.33604" fill="currentColor"></path>
                                    </svg>                         
                                </button>

                                <button
                                    className="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addDistributorModal"
                                >
                                    <span className="btn-inner mr-5">
                                        <svg
                                            width="32"
                                            height="32"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="icon-24"
                                        >
                                            <path
                                                d="M12 4V20M20 12H4"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                    Agregar
                                </button>
                                </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                <table id="datatable" class="table table-striped" data-toggle="data-table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Plan</th>
                                            <th>Contraseña</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {loadingDistributors ? (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                                                    <div className="col-md-12 col-sm-4 mb-4">
                                                        <div className="iq-loader-box">
                                                            <div className="iq-loader-1"></div>
                                                        </div>
                                                    </div>

                                                    <span className="text-muted">
                                                        Cargando distribuidores...
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : filteredDistributors.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No hay distribuidores registrados
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedItems.map((disty) => {
                                            const isPasswordVisible = !!visiblePasswords[disty.Disty_ID];
                                            const safePassword = disty.Password_Default || "";
                                            const maskedPassword = safePassword ? "•".repeat(safePassword.length) : "••••••";

                                            return (
                                                <tr key={disty.Disty_ID}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            {/* <img
                                                                className="rounded img-fluid me-3"
                                                                src={disty.Disty_Imagen || "/assets/images/default-image.jpg"}
                                                                alt={disty.Disty_Nombre}
                                                                loading="lazy"
                                                                style={{width:'10%'}}
                                                            /> */}
                                                            <h6 className="mb-0">{disty.Disty_Nombre}</h6>
                                                        </div>
                                                    </td>

                                                    <td>{disty.Plan_Nombre || "-"}</td>

                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-icon btn-primary-subtle rounded-pill btn-sm"
                                                                onClick={() => toggleDistributorPassword(disty.Disty_ID)}
                                                                title={isPasswordVisible ? "Ocultar contraseña" : "Ver contraseña"}
                                                            >
                                                                {isPasswordVisible ? (
                                                                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                                        <path d="M9.76045 14.3667C9.18545 13.7927 8.83545 13.0127 8.83545 12.1377C8.83545 10.3847 10.2474 8.97168 11.9994 8.97168C12.8664 8.97168 13.6644 9.32268 14.2294 9.89668" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M15.1049 12.6987C14.8729 13.9887 13.8569 15.0067 12.5679 15.2407" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6.65451 17.4722C5.06751 16.2262 3.72351 14.4062 2.74951 12.1372C3.73351 9.85823 5.08651 8.02823 6.68351 6.77223C8.27051 5.51623 10.1015 4.83423 11.9995 4.83423C13.9085 4.83423 15.7385 5.52623 17.3355 6.79123" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M19.4473 8.99072C20.1353 9.90472 20.7403 10.9597 21.2493 12.1367C19.2823 16.6937 15.8063 19.4387 11.9993 19.4387C11.1363 19.4387 10.2853 19.2987 9.46729 19.0257" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M19.8868 4.24951L4.11279 20.0235" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                ) : (
                                                                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1614 12.0531C15.1614 13.7991 13.7454 15.2141 11.9994 15.2141C10.2534 15.2141 8.83838 13.7991 8.83838 12.0531C8.83838 10.3061 10.2534 8.89111 11.9994 8.89111C13.7454 8.89111 15.1614 10.3061 15.1614 12.0531Z" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.998 19.355C15.806 19.355 19.289 16.617 21.25 12.053C19.289 7.48898 15.806 4.75098 11.998 4.75098H12.002C8.194 4.75098 4.711 7.48898 2.75 12.053C4.711 16.617 8.194 19.355 12.002 19.355H11.998Z" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </button>
                                                            <span style={{ minWidth: "100px" }}>
                                                                {isPasswordVisible ? safePassword : maskedPassword}
                                                            </span>

                                                            
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="d-flex">
                                                            <button
                                                                type="button"
                                                                className="btn btn-icon btn-info-subtle ms-2"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#viewDistyModal"
                                                                onClick={() => handleViewDisty(disty.Disty_ID)}
                                                            >
                                                                <span className="btn-inner">
                                                                    <svg
                                                                        className="icon-32"
                                                                        width="32"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            opacity="0.4"
                                                                            fillRule="evenodd"
                                                                            clipRule="evenodd"
                                                                            d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z"
                                                                            fill="currentColor"
                                                                        />
                                                                        <path
                                                                            d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z"
                                                                            fill="currentColor"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-icon btn-warning-subtle ms-2"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#editDistyModal"
                                                                onClick={() => handleEditDisty(disty.Disty_ID)}
                                                            >
                                                                <span className="btn-inner">
                                                                    <svg
                                                                        className="icon-32"
                                                                        width="32"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            opacity="0.4"
                                                                            d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                            fill="currentColor"
                                                                        />
                                                                        <path
                                                                            d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                            fill="currentColor"
                                                                        />
                                                                        <path
                                                                            opacity="0.4"
                                                                            d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                            fill="currentColor"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-icon btn-danger-subtle ms-2"
                                                                onClick={() => handleDeactivateDisty(disty)}
                                                            >
                                                                <span className="btn-inner">
                                                                    <svg
                                                                        className="icon-32"
                                                                        width="32"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            opacity="0.4"
                                                                            d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                            fill="currentColor"
                                                                        />
                                                                        <path
                                                                            d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                            fill="currentColor"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                                </table>
                                </div>
                            </div>

                            <UniversalPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                startItem={startItem}
                                endItem={endItem}
                                visiblePages={visiblePages}
                                onPageChange={goToPage}
                                onPrevious={goToPreviousPage}
                                onNext={goToNextPage}
                                hasPreviousPage={hasPreviousPage}
                                hasNextPage={hasNextPage}
                            />
                        </div>
                    </div>
                </div>

                {/* Modal para agregar distribuidor */}
                <div
                    className="modal fade"
                    id="addDistributorModal"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Agregar Distribuidor
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={resetAddDistyForm}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="nombre">
                                            Nombre:
                                        </label>
                                        <input
                                            id="nombre"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ingresa el nombre de distribuidor"
                                            value={distyNombre}
                                            onChange={(e) => setDistyNombre(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="col">
                                        <label className="form-label" htmlFor="password">
                                            Password
                                        </label>

                                        <div className="position-relative">
                                            <input
                                                id="password"
                                                type={showPassword ? "text" : "password"}
                                                className="form-control pe-5"
                                                placeholder="Ingresa la contraseña predeterminada"
                                                value={distyPassword}
                                                onChange={(e) => setDistyPassword(e.target.value)}
                                                required
                                            />

                                            <button
                                                type="button"
                                                className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent shadow-none"
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{ zIndex: 5 }}
                                            >
                                                {showPassword ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        fill="currentColor"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M13.359 11.238 15 12.879l-.707.707-1.73-1.73A8.46 8.46 0 0 1 8 13.5c-3 0-5.5-1.833-7-5  .617-1.304 1.41-2.35 2.335-3.165L1 2.707 1.707 2l12 12-.707.707-.64-.64zM11.297 9.883l-1.532-1.532a2 2 0 0 1-2.116-2.116L6.117 4.703A3 3 0 0 0 8 11a2.98 2.98 0 0 0 1.883-.703z" />
                                                        <path d="M10.477 7.649A2 2 0 0 0 8.351 5.523l2.126 2.126zM8 3.5c3 0 5.5 1.833 7 5a8.7 8.7 0 0 1-1.935 2.707l-.708-.708A7.63 7.63 0 0 0 14 8.5c-1.305-2.611-3.305-4-6-4-.84 0-1.64.134-2.39.395l-.77-.77A8.82 8.82 0 0 1 8 3.5z" />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        fill="currentColor"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.12 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                        <path d="M8 5.5A2.5 2.5 0 1 0 8 10.5 2.5 2.5 0 0 0 8 5.5zm0 1A1.5 1.5 0 1 1 8 9.5 1.5 1.5 0 0 1 8 6.5z" />
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="region">
                                            Región:
                                        </label>
                                        <select
                                            id="region"
                                            className="form-select mb-3 shadow-none"
                                            value={distyRegionId}
                                            onChange={(e) => setDistyRegionId(e.target.value)}
                                            required
                                        >
                                            <option value="">Selecciona una Región</option>
                                            {regions.map((region) => (
                                                <option key={region.Region_ID} value={region.Region_ID}>
                                                    {region.Region_Nombre}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col">
                                        <label className="form-label" htmlFor="plan">
                                            Plan
                                        </label>
                                        <select
                                            id="plan"
                                            className="form-select mb-3 shadow-none"
                                            value={distyPlanId}
                                            onChange={(e) => setDistyPlanId(e.target.value)}
                                            required
                                        >
                                            <option value="">Selecciona un Plan</option>
                                            {plans.map((plan) => (
                                                <option key={plan.Plan_ID} value={plan.Plan_ID}>
                                                    {plan.Plan_Nombre}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="customFile1">
                                            Selecciona una imagen:
                                        </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            id="customFile1"
                                            accept=".jpg,.jpeg,.png,.webp"
                                            onChange={handleDistributorImageChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {successMessage && (
                                    <div
                                        className="mb-3 alert alert-left alert-success alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <span>{successMessage}</span>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            data-bs-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => setSuccessMessage("")}
                                        ></button>
                                    </div>
                                )}

                                {infoMessage && (
                                    <div
                                        className="mb-3 alert alert-top alert-info alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <span>{infoMessage}</span>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            data-bs-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => setInfoMessage("")}
                                        ></button>
                                    </div>
                                )}

                                {errorMessage && (
                                    <div
                                        className="alert alert-bottom alert-danger alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <span>{errorMessage}</span>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            data-bs-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => setErrorMessage("")}
                                        ></button>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={resetAddDistyForm}
                                    disabled={savingDisty}
                                >
                                    Cerrar
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSaveDistributor}
                                    disabled={savingDisty}
                                >
                                    {savingDisty ? "Guardando..." : "Guardar"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal para ver distribuidor */}
                <div
                    className="modal fade"
                    id="viewDistyModal"
                    tabIndex="-1"
                    aria-labelledby="viewDistyModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="viewDistyModalLabel">
                                    Detalle del Distribuidor
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {loadingViewDisty ? (
                                    <div className="text-center py-4">
                                        Cargando detalle del distribuidor...
                                    </div>
                                ) : viewDistyError ? (
                                    <div className="alert alert-danger" role="alert">
                                        {viewDistyError}
                                    </div>
                                ) : !viewDistyData ? (
                                    <div className="alert alert-info" role="alert">
                                        No hay información disponible del distribuidor.
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-12 mb-3 text-center">
                                            <img
                                                src={viewDistyData.Disty_Imagen}
                                                alt={viewDistyData.Disty_Nombre}
                                                className="rounded img-fluid"
                                                style={{
                                                    maxWidth: "160px",
                                                    maxHeight: "160px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-bold">Nombre</label>
                                            <div className="form-control">
                                                {viewDistyData.Disty_Nombre || "-"}
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-bold">Región</label>
                                            <div className="form-control">
                                                {viewDistyData.Region_Nombre || "-"}
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-bold">Plan</label>
                                            <div className="form-control">
                                                {viewDistyData.Plan_Nombre || "-"}
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-bold">
                                                Contraseña predeterminada
                                            </label>

                                            <div className="position-relative">
                                                <input
                                                    type={showViewDistyPassword ? "text" : "password"}
                                                    className="form-control pe-5"
                                                    value={viewDistyData.Password_Default || ""}
                                                    readOnly
                                                />

                                                <button
                                                    type="button"
                                                    className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent shadow-none"
                                                    onClick={() => setShowViewDistyPassword(!showViewDistyPassword)}
                                                >
                                                    <i className={showViewDistyPassword ? "feather-eye-off" : "feather-eye"}></i> Ocultar
                                                </button>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-bold">Estatus</label>
                                            <div className="form-control">
                                                {Number(viewDistyData.Disty_Activo) === 1 ? "Activo" : "Inactivo"}
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label fw-bold">Última actualización</label>
                                            <div className="form-control">
                                                {viewDistyData.Disty_Act
                                                    ? new Date(viewDistyData.Disty_Act).toLocaleString("es-MX")
                                                    : "-"}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal para editar distribuidor */}
                <div
                    className="modal fade"
                    id="editDistyModal"
                    tabIndex="-1"
                    aria-labelledby="editDistyModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editDistyModalLabel">
                                    Editar Distribuidor
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {loadingEditDisty ? (
                                    <div className="text-center py-4">
                                        Cargando información del distribuidor...
                                    </div>
                                ) : (
                                    <>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <label className="form-label">Nombre:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editDistyNombre}
                                                    onChange={(e) => setEditDistyNombre(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="col">
                                                <label className="form-label">
                                                    Nueva contraseña predeterminada
                                                </label>

                                                <div className="position-relative">
                                                    <input
                                                        type={showEditDistyPassword ? "text" : "password"}
                                                        className="form-control pe-5"
                                                        placeholder="Déjala vacía si no deseas cambiarla"
                                                        value={editDistyPassword}
                                                        onChange={(e) => setEditDistyPassword(e.target.value)}
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent shadow-none"
                                                        onClick={() => setShowEditDistyPassword(!showEditDistyPassword)}
                                                        style={{ zIndex: 5 }}
                                                    >
                                                        <i className={showEditDistyPassword ? "feather-eye-off" : "feather-eye"}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col">
                                                <label className="form-label">Región:</label>
                                                <select
                                                    className="form-select mb-3 shadow-none"
                                                    value={editDistyRegionId}
                                                    onChange={(e) => setEditDistyRegionId(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Selecciona una Región</option>
                                                    {regions.map((region) => (
                                                        <option key={region.Region_ID} value={region.Region_ID}>
                                                            {region.Region_Nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col">
                                                <label className="form-label">Plan:</label>
                                                <select
                                                    className="form-select mb-3 shadow-none"
                                                    value={editDistyPlanId}
                                                    onChange={(e) => setEditDistyPlanId(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Selecciona un Plan</option>
                                                    {plans.map((plan) => (
                                                        <option key={plan.Plan_ID} value={plan.Plan_ID}>
                                                            {plan.Plan_Nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-8">
                                                <label className="form-label">
                                                    Cambiar imagen:
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png,.webp"
                                                    onChange={handleEditDistyImageChange}
                                                />
                                            </div>

                                            <div className="col-md-4 text-center">
                                                <label className="form-label d-block">
                                                    Imagen actual
                                                </label>
                                                {editDistyImageUrl ? (
                                                    <img
                                                        src={editDistyImageUrl}
                                                        alt={editDistyNombre}
                                                        className="rounded img-fluid"
                                                        style={{
                                                            maxWidth: "90px",
                                                            maxHeight: "90px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="alert alert-info py-2">
                                                        Sin imagen
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {editDistySuccess && (
                                            <div className="mb-3 alert alert-left alert-success alert-dismissible fade show" role="alert">
                                                <span>{editDistySuccess}</span>
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white"
                                                    onClick={() => setEditDistySuccess("")}
                                                ></button>
                                            </div>
                                        )}

                                        {editDistyInfo && (
                                            <div className="mb-3 alert alert-top alert-info alert-dismissible fade show" role="alert">
                                                <span>{editDistyInfo}</span>
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white"
                                                    onClick={() => setEditDistyInfo("")}
                                                ></button>
                                            </div>
                                        )}

                                        {editDistyError && (
                                            <div className="alert alert-bottom alert-danger alert-dismissible fade show" role="alert">
                                                <span>{editDistyError}</span>
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white"
                                                    onClick={() => setEditDistyError("")}
                                                ></button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    disabled={savingEditDisty}
                                >
                                    Cerrar
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleUpdateDisty}
                                    disabled={savingEditDisty || loadingEditDisty}
                                >
                                    {savingEditDisty ? "Guardando..." : "Guardar cambios"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </main>
        </>
    )
}

export default ConfigDistribuidor